import React from "react";
import {
  Col,
  Container,
  Row,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { useState } from "react";
import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";
import axios from "axios";
import { useEffect } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingSetData from "../TESTPage/LoadingSetData";
import TableForm from "./TableForm";
import { useLocation, useNavigate } from "react-router-dom";
import TableApprove from "./WaitApprove/TableApprove";
import { CheckBudgetYear } from "../Function/CheckBudgetYear";

const baseURL = process.env.REACT_APP_API_CORS;

const TableLeave = () => {
  const location = useLocation();
  const paramValue = new URLSearchParams(location.search).get("menu") || "";
  const navigate = useNavigate();
  const [activeTab, setactiveTab] = useState(paramValue);
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user.user_id;

  const [leaveData, setLeaveData] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leavePagination, setLeavePagination] = useState({
    currentPage: 0,
    totalPage: 0,
    totalRows: 0,
  });
  const getLeaveData = async (page = 1, isFromIndex = true) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: page,
        size: isFromIndex ? 5 : 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[budget_year][0]": CheckBudgetYear(),
        "filter[leave_status][0]": isFromIndex ? 2 : "",
        "filter[leave_status][1]": isFromIndex ? 3 : "",
        "filter[leave_status][2]": isFromIndex ? 4 : "",
        "filter[leave_status][3]": isFromIndex ? 7 : "",
        "filter[leave_status][4]": isFromIndex ? 9 : "",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveData(res?.data?.result);
      setLeavePagination((prev) => ({
        ...prev,
        currentPage: res?.data?.info?.currentPage,
        totalPage: res?.data?.info?.totalPage,
        totalRows: res?.data?.info?.totalRows,
      }));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const res = await axios.get(baseURL + "/api/users/info", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserInfo(res.data.result);
      } catch (err) {
        console.error();
      }
    };
    getUserInfo();
    getLeaveData(1, false);
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const RefreshLeaveDataTable = async (isFromIndex = false) => {
    try {
      const url = baseURL + `/api/leave/datatable`;
      const params = new URLSearchParams({
        page: 1,
        size: isFromIndex ? 5 : 10,
        "order[0]": "created_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[leave_status][0]": 2,
        "filter[leave_status][1]": 3,
        "filter[leave_status][2]": 4,
        // "filter[leave_status][3]": 7,
        "filter[leave_status][4]": 9,
        "filter[budget_year][0]": CheckBudgetYear(),
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLeaveData(res?.data?.result);
      setLeavePagination((prev) => ({
        ...prev,
        currentPage: res?.data?.info?.currentPage,
        totalPage: res?.data?.info?.totalPage,
        totalRows: res?.data?.info?.totalRows,
      }));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="page-content">
      {!loading ? (
        <LoadingSetData />
      ) : (
        <FadeIn>
          <Container fluid>
            <Breadcrumb
              title="การลาออนไลน์"
              breadcrumbItem={paramValue === 'allowleaveorder' ? 'รายการรอหัวหน้าอนุมัติ' : 'ตารางข้อมูลการลา'}
              isBack={true}
              path="/leave"
            />
            <div className="checkout-tabs">
              <Row className="d-flex justify-content-center">
                <Col xxl={11}>
                  {activeTab === "leavedatatable" ? (
                    <FadeIn>
                      <TableForm
                        isFromIndex={false}
                        userInfo={userInfo}
                        user_id={user_id}
                        leaveData={leaveData}
                        leavePagination={leavePagination}
                        setLeaveData={setLeaveData}
                        setLeavePagination={setLeavePagination}
                        getLeaveData={getLeaveData}
                        RefreshLeaveDataTable={RefreshLeaveDataTable}
                      />
                    </FadeIn>
                  )
                    // : activeTab === "รายการรอหัวหน้าอนุมัติ" ? (
                    //   <FadeIn>
                    //     <TableWaitingLeader isFromIndex={false} selectRow={10} />
                    //   </FadeIn>
                    // ) 
                    : activeTab === "allowleaveorder" ? (
                      <FadeIn>
                        <TableApprove isFromIndex={false} selectRow={10} />
                      </FadeIn>
                    ) : null}
                </Col>
              </Row>
            </div>
          </Container>
        </FadeIn>
      )}
    </div>
  );
};

export default TableLeave;
